import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import toColorString from 'polished/lib/color/toColorString';

import { spacing } from '@decisiv/design-tokens';
import color from '@decisiv/design-tokens/lib/color';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const BannerContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const TitleActionButton = styled.div`
  position: absolute;
  top: ${rem(spacing.base * 1.3)};
  right: ${rem(spacing.base * 1.6)};
  z-index: 1;
`;

export const BannerContent = styled(Flex)`
  width: 100%;
  flex-direction: column;
  gap: ${rem(spacing.base)};
`;

export const ContactCard = styled(Flex)`
  align-items: center;
  padding: ${rem(spacing.base)};
  gap: ${rem(spacing.base)};
  background-color: ${toColorString(color.opacity.fullMoon50)};
  border-radius: 2px;
`;
